import React from 'react';
import HeaderSimplePage from 'Components/HeaderMobile/SimplePage';
import Icon from 'Components/Icon';
import assetUrl from 'Utils/assetUrl';
import EnvironmentManager from 'Utils/environmentManager';

const stores = [
  {
    id: 0,
    type: 'appstore',
    icon: assetUrl('appleLogo.png'),
    storeIcon: assetUrl('appSLogo.png'),
    title: "App Store'dan indirin",
    qr: 'svgQrCodeApple',
    link: EnvironmentManager.getMessageText({ key: 'ios_indir_download_url' }) || 'https://app.adjust.com/8wyq7yf?engagement_type=fallback_click',
  },
  {
    id: 1,
    type: 'appgallery',
    icon: assetUrl('huaweiLogo.png'),
    storeIcon: assetUrl('huaweiSLogo.png'),
    title: 'AppGallery ile keşfedin',
    qr: 'svgQrCodeHuawei',
    link: 'https://app.adjust.com/12cimxml?engagement_type=fallback_click&redirect=https%3A%2F%2Fappgallery.huawei.com%2F%23%2Fapp%2FC108310847'
  },
  {
    id: 2,
    type: 'android',
    icon: assetUrl('androidLogo_H1LoIUI.png'),
    storeIcon: assetUrl('androidSLogo_e6sZeyG.png'),
    title: "Google Play'den indirin",
    qr: 'svgQrCodeAndroid',
    link: EnvironmentManager.getMessageText({ key: 'footer_download_url' }) || 'https://app.adjust.com/11dirj6e?deep_link=bilyoner%3A%2F%2F'
  },
  {
    id: 3,
    type: 'galaxystore',
    icon: assetUrl('galaxyLogo.png'),
    storeIcon: assetUrl('galaxySLogo.png'),
    title: "Galaxy Store'dan indirin",
    qr: 'svgQrCodeGalaxy',
    link: 'https://app.adjust.com/12ema1ey?engagement_type=fallback_click&redirect=https%3A%2F%2Fgalaxystore.samsung.com%2Fdetail%2Fcom.bilyoner.app'
  },
];

const MobileApps = () => {


  return (
    <>
      <HeaderSimplePage color="green" title="Mobil Uygulamalarımız" />
      <div className="page page--mobile-apps">
        <div className="mobile-apps-container">
          {
            stores.map(store => (
              <div className="mobile-apps__app-section" key={ store.id }>
                <div className="mobile-apps__app-section__links">
                  <a title={ store.title } href={ store.link } rel="noopener noreferrer" target="_blank">
                    <img className='mobile-apps__logo--apple-store' src={ store.storeIcon } alt={ store.type } loading="lazy" />
                  </a>
                  <Icon className='mobile-apps__qr' iconName={ store.qr } />
                </div>
              </div>
            ))
          }
          <div>
            <h1 className="mobile-apps__title text-center">Bilyoner Mobil Uygulaması Her Daim Cebinizde</h1>
            <p className="mobile-apps__text text-300">
              Bahsin ilk adresi Bilyoner mobil uygulaması ile her an yanınızda. Bahis oynamak, kupon yapmak ve bahsin renkli dünyasına adım atmak için Bilyoner indirmeniz yeterli. Bilyoner uygulaması üzerinden güncel karşılaşmaları takip edebilir, canlı olarak oynanan maçlara bahis oluşturabilir ve anlık kupon yapabilirsiniz. Bilyoner uygulamasını indirerek siz de bahis keyfine ortak olmaya hazır olun!
            </p>
            <h2 className="mobile-apps__title text-300">
              Canlı Sonuçlar Parmağınızın Ucunda
            </h2>
            <p className="mobile-apps__text text-300">
              Türkiye&apos;nin ilk yasal bahis sitesi Bilyoner iOS ve Android uygulamaları ile karşınızda. Siz de hemen şimdi Bilyoner iOS ve Android uygulamaları indirerek bahis yapmaya başlayabilirsiniz. Mobil uygulama sayesinde cep telefonunuzdan kupon oluşturabilir, istatistik ve yazar yorumlarını inceleyebilir, merak ettiğiniz ligler ve maçlar hakkında kapsamlı bilgi edinebilirsiniz. Uygulamanın Canlı Sonuçlar bölümünden anlık olarak skor tablolarını takip edebilir, karşılaşmalardaki gol bildirimlerinin de anlık olarak cep telefonunuza gelmesini sağlayabilirsiniz.
            </p>
            <h2 className="mobile-apps__title text-300">
              Bilyoner Uygulamasıyla Kupon Yapmak Çok Kolay
            </h2>
            <p className="mobile-apps__text text-300">
              Avrupa maçlarından Türkiye liglerine, basketboldan tenise pek çok farklı karşılaşmayı güncel olarak takip edebileceğiniz Bilyoner uygulaması üzerinden en hızlı şekilde kuponunuzu hazırlayabilir, Canlı İddaa oynamanın tadına varabilirsiniz. Uygulama aynı zamanda canlı skor ve istatistik takibi yapmanıza, farklı canlı skor uygulamalarına ihtiyaç duymadan, tek bir platform üzerinden kesintisiz bir bahis deneyimi yaşamanıza olanak sunuyor. Akıllı Analiz özelliği sayesinde takım detaylarını maç kartından görüntüleyebileceğiniz gibi, bu analiz verilerine dayanarak kuponunuza dair öngörüler ve tahminlerde bulunabilirsiniz.
            </p>
            <h2 className="mobile-apps__title text-300">
              Bu Tribün Sizin!
            </h2>
            <p className="mobile-apps__text text-300">
              Sporseverlerin favorisi Bilyoner, size özel Tribün paylaşım platformu sayesinde etkileşimlerinize keyif katıyor. Kuponlarınızı Tribün özelliği üzerinden paylaşabilir, diğer kullanıcıların kuponlarını inceleyebilir, ilginizi çeken kuponlara yorum yapabilir ve onları beğenebilirsiniz. Bununla birlikte mobil cihazınıza Bilyoner yükleyerek Anında Ödeme özelliğinden faydalanabilirsiniz. İşleminizi tamamladıktan sonra günün dilediğiniz saatinde hesabınıza anında para transferi yapabilir, para yatırma ve para çekme işlemlerinizi 7/24 gerçekleştirebilirsiniz.
            </p>
            <h2 className="mobile-apps__title text-300">
              Bahsin Keyfi Bilyoner’le Çıkar
            </h2>
            <p className="mobile-apps__text text-300">
              Siz de Bilyoner&apos;e üye olarak İddaa programlarına, kuponlara ve canlı maç sonuçlarına birkaç zahmetsiz adımda erişebilirsiniz. Süper Lig&apos;den Bundesliga&apos;ya, Premier Lig&apos;den La Liga&apos;ya futbol en coşkulu liglerini ve maçlarını Bilyoner uygulaması ile deneyimleyebilirsiniz. Bilyoner mobil uygulamasıyla bahis oynamak ve kupon yapmak artık çok daha kolay, çok daha keyifli!
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileApps;
